module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('fieldset', {
    staticClass: "margin-b-10"
  }, [_c('legend', [_vm._v("PowerOffice Credentials")]), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Client Key"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Enter Client Key"
    },
    model: {
      value: (_vm.form.fields.poweroffice_client_key.value),
      callback: function($$v) {
        _vm.$set(_vm.form.fields.poweroffice_client_key, "value", $$v)
      },
      expression: "form.fields.poweroffice_client_key.value"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Company Slug"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Enter Company Slug"
    },
    model: {
      value: (_vm.form.fields.poweroffice_company_slug.value),
      callback: function($$v) {
        _vm.$set(_vm.form.fields.poweroffice_company_slug, "value", $$v)
      },
      expression: "form.fields.poweroffice_company_slug.value"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Integration Type"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Select Integration Type"
    },
    model: {
      value: (_vm.form.fields.poweroffice_integration_type.value),
      callback: function($$v) {
        _vm.$set(_vm.form.fields.poweroffice_integration_type, "value", $$v)
      },
      expression: "form.fields.poweroffice_integration_type.value"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Direct",
      "value": "direct"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Iframe",
      "value": "iframe"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "margin-t-10"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.saveSettings
    }
  }, [_vm._v("\n        Update Settings\n      ")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a131909e","hasScoped":false}!./src/app/components/powerofficeCredentialsModal/powerofficeCredentialsModal.html
// module id = 3099
// module chunks = 1